<div class="container entity-sidesheet-status contact-sidesheet-status" (mousedown)="onClickSetEventValue($event)"
    (click)="onClickSetEventValue($event)" tid="add_relationship_dialog">
    <tam-dialog tid="add-entity-dialog" [opened]="dialogOpened" [dialogWidth]="696"
        (containerEvent)="onContainerEvent($event)">
        <ng-template #title>
            <div class="dialog-title">{{dialogTitle}}</div>
            <smart-icon class="dialog-close dark" name="close" (click)="cancel()">
            </smart-icon>
        </ng-template>
        <ng-template #body>
            <div class="body-container">
                <div class="add-entity-panel" tid="add_entity_panel">
                    <filter-panel [config]="filterConfig"></filter-panel>
                </div>
                <div class="add-button-panel" tid="add-button-panel">
                    <div class="filter-body-container" tid="filter_container">
                        <kendo-dropdownbutton [popupSettings]="{appendTo: viewContainer}" [data]="filterSource"
                            [textField]="'textField'" [iconClass]="'k-button'" tid="dropdown_button">
                        </kendo-dropdownbutton>
                    </div>
                    <div class="checkbox-item-container">
                        <label class="checkbox-item" tam-checkbox [(ngModel)]="isReplaceWithCreatedEntity"
                            *ngIf="isReplaceExistingShow" tid="replace_relationship">
                            Replace Existing Relationship(s)
                        </label>
                        <label class="checkbox-item" tam-checkbox [(ngModel)]="isCreatWithReciprocalRel"
                            *ngIf="isCreatWithReciprocalRelShow" tid="create_reciprocal_relationship">
                            Create Reciprocal Relationship(s)
                        </label>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #footer>
            <div class="footer-container">
                <button tam-button [tamType]="'tertiary'" [tamSize]="'normal'" (click)="cancel()"
                    tid="cancel">Cancel</button>
                <button tam-button [tamType]="'primary'" [tamSize]="'normal'" (click)="apply()"
                    [tamLoading]="isApplying" tid="apply">Apply</button>
            </div>
        </ng-template>
    </tam-dialog>
</div>